import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AppLayout } from '@/layouts/AppLayout';
import { AuthGate } from '@/components/auth/AuthGate';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';

import { FeedPage } from '@/pages/FeedPage';
import { AuctionPage } from '@/pages/AuctionPage';
import { CreateAuctionPage } from '@/pages/CreateAuctionPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { MyAuctionsPage } from '@/pages/MyAuctionsPage';
import { UserProfilePage } from '@/pages/UserProfilePage';
import { NotificationsPage } from '@/pages/NotificationsPage';
import { AdminPage } from '@/pages/AdminPage';
import { PlaceholderPage } from '@/pages/PlaceholderPage';
import { FaqPage } from '@/pages/FaqPage';

const QueryDevtools = import.meta.env.DEV
  ? lazy(() => import('@/lib/QueryDevtools').then((m) => ({ default: m.QueryDevtools })))
  : () => null;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const App = () => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthGate>
          <AppLayout>
            <Routes>
              <Route path="/" element={<FeedPage />} />
              <Route path="/auction/:id" element={<AuctionPage />} />
              <Route path="/create" element={<CreateAuctionPage />} />
              <Route path="/edit/:id" element={<CreateAuctionPage />} />
              <Route path="/my" element={<MyAuctionsPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/user/:id" element={<UserProfilePage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="*" element={<PlaceholderPage title="404" subtitle="Страница не найдена" />} />
            </Routes>
          </AppLayout>
          </AuthGate>
        </BrowserRouter>
        {import.meta.env.DEV && (
          <Suspense fallback={null}>
            <QueryDevtools />
          </Suspense>
        )}
      </QueryClientProvider>
    </ErrorBoundary>
  );
};